import { useSelector } from "react-redux";
import { Outlet } from "react-router-dom";

import { ADMIN_NOT_FOUND_SX } from "@/apps/admin/components/Layout/notFoundSx";
import { OBJECT_NAME } from "@/apps/admin/enums/objectName";
import { OBJECT_TYPE } from "@/apps/admin/enums/objectType";
import { selectPermissions } from "@/apps/admin/features/authentication/authenticationSlice";
import { checkGlobalManagementRolePermission } from "@/apps/admin/utilities/data";
import NotFound from "@/common/components/NotFound/NotFound";

/**
 * Genie behaviour & knowledge (GEN5-5344) is for TSC's own admin management
 * only: global `management.manage`, the permission chat-service's
 * ManagementManageGuard checks on every knowledge and behaviour route (and the
 * one GeniePlus calls `manageAll`). Global `management.read`, which opens the
 * admin app, is not enough. The menu, the landing card and the route all ask
 * this one question.
 */
export const canUseGenieKnowledge = (permissions: unknown): boolean =>
  checkGlobalManagementRolePermission(
    permissions,
    OBJECT_TYPE.MANAGEMENT,
    OBJECT_NAME.MANAGE
  );

/**
 * The page's route: its page for TSC admin management, the admin not-found
 * page for anyone else. GlobalLayout renders the Outlet only once the
 * permissions have loaded, so this never decides on an empty list.
 */
export const GenieKnowledgeGate = () => {
  const permissions: unknown = useSelector(selectPermissions);
  return canUseGenieKnowledge(permissions) ? (
    <Outlet />
  ) : (
    <NotFound sx={ADMIN_NOT_FOUND_SX} />
  );
};
